<mat-sidenav-container class="h-100">
  <div class="login-outer-flex h-100">
    <div class="login-inner-flex h-100">
      <form [formGroup]="formGroup" class="mat-elevation-z6">
        <div class="login-header bg-primary login-header-flex" [class.bg-image]="true">
          <img class="login-logo" [src]="getLogo" alt="logo" />
          <div class="title login-title-flex">{{ getLoginTitle }}</div>
        </div>

        <div class="p-3">
          <mat-form-field class="w-100">
            <mat-label>Client</mat-label>
            <input matInput placeholder="Client" formControlName="client" />
            @if (clientHasError) {
              <mat-error>{{ clientError }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="w-100">
            <mat-label>Saml Assertion</mat-label>
            <input matInput formControlName="saml" />
            @if (samlHasError) {
              <mat-error>{{ samlError }}</mat-error>
            }
          </mat-form-field>
          <button mat-raised-button color="primary" class="mat-elevation-z6 w-100 mt-3" type="submit" (click)="login()">
            @if (loading) {
              <mat-icon>
                <mat-spinner color="accent" diameter="20" />
              </mat-icon>
            }
            @if (!loading) {
              <span>Login</span>
            }
          </button>
        </div>
      </form>
    </div>
    <div class="login-footer-flex">
      <div class="p-3">
        <div class="text-center">
          {{ getClient }}
        </div>
      </div>
    </div>
  </div>
</mat-sidenav-container>
